<template>
  <base-progress
    v-slot="{ percentage }"
    v-bind="$props"
    class="h-2.5 overflow-hidden rounded bg-grey-70 outline-1 forced-colors:outline"
    :class="{ 'o:h-1': variant === 'loyalty' }"
    data-test-id="vf-progress-bar"
    role="presentation"
  >
    <div
      class="h-full rounded bg-brand-1 bg-brand-6 forced-colors:o:bg-[ButtonBorder]"
      :class="[classProgress, { 'bg-green-30': variant === 'loyalty' }]"
      :style="`width: ${percentage}%`"
    />
  </base-progress>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'

defineProps<{
  /**
   * Defines maximum (total) value that can be achieved
   */
  max?: number | string
  /**
   * Defines current value
   */
  value?: number | string
  /**
   * Classes to be applied to the progress
   */
  classProgress?: CSSClass
  /**
   * Styling variants
   */
  variant?: 'loyalty'
}>()
</script>
